import React, { useState, useEffect } from "react";
import "./salesperson-dashboard.css";
import targetIcon from "../../assets/svg/target_ic.svg";
import achievedIcon from "../../assets/svg/achieved.svg";
import achievedPercentIcon from "../../assets/svg/achieved-percent_ic.svg";
import orderClosedIcon from "../../assets/svg/order-closed.svg";
import pendingIcon from "../../assets/svg/pending_order_ic.svg";
import revenueIcon from "../../assets/svg/revenue.svg";
import orderIcon from "../../assets/svg/order-grey.svg";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { Doughnut, Bar } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
);
export const SalespersonDashboard = () => {
  const navigate = useNavigate();
  const [performanceTab, setPerformanceTab] = useState("Top Sales Persons");
  const [summaryTab, setSummaryTab] = useState("Sales Persons");
  const [selectedChannel, setSelectedChannel] = useState("Channel");

  // Sample data - replace with actual API calls
  const [metricsData, setMetricsData] = useState({
    totalTarget: { value: 56, amount: "₹25,00,000" },
    totalAchieved: { value: 67, amount: "₹25,00,000" },
    achievementPercent: "73.6%",
    ordersClosed: { value: 45, amount: "₹25,00,000" },
    pendingOrders: { value: 12, amount: "₹25,00,000" },
  });

  const salesPersonsData = [
    {
      id: 1,
      name: "Aravinsh Kumar",
      role: "Sales Head",
      rank: 1,
      achievement: 78,
      revenue: "₹3,50,000",
      target: "₹1,00,000",
      orders: 32,
      groups: 5,
      profileImage: null,
    },
    {
      id: 2,
      name: "Aravinsh Kumar",
      role: "Sales Head",
      rank: 2,
      achievement: 78,
      revenue: "₹6,50,000",
      target: "₹1,00,000",
      orders: 32,
      groups: 5,
      profileImage: null,
    },
    {
      id: 3,
      name: "Aravinsh Kumar",
      role: "Sales Head",
      rank: 3,
      achievement: 78,
      revenue: "₹3,50,000",
      target: "₹1,00,000",
      orders: 32,
      groups: 5,
      profileImage: null,
    },
    {
      id: 4,
      name: "Aravinsh Kumar",
      role: "Sales Head",
      rank: 4,
      achievement: 78,
      revenue: "₹3,50,000",
      target: "₹1,00,000",
      orders: 32,
      groups: 5,
      profileImage: null,
    },
    {
      id: 5,
      name: "Aravinsh Kumar",
      role: "Sales Head",
      rank: 5,
      achievement: 78,
      revenue: "₹6,50,000",
      target: "₹1,00,000",
      orders: 32,
      groups: 5,
      profileImage: null,
    },
    {
      id: 6,
      name: "Aravinsh Kumar",
      role: "Sales Head",
      rank: 6,
      achievement: 78,
      revenue: "₹6,50,000",
      target: "₹1,00,000",
      orders: 32,
      groups: 5,
      profileImage: null,
    },
  ];

  const performanceSummary = [
    {
      id: 1,
      salesPerson: "Sabarinathan S",
      phone: "PH: 9876543210",
      orders: 23,
      amount: "₹23,000",
      collectedPayment: "₹23,000",
      outstanding: "₹66,786",
    },
    {
      id: 2,
      salesPerson: "Sabarinathan S",
      phone: "PH: 9876543210",
      orders: 23,
      amount: "₹23,000",
      collectedPayment: "₹23,000",
      outstanding: "₹66,786",
    },
    {
      id: 3,
      salesPerson: "Sabarinathan S",
      phone: "PH: 9876543210",
      orders: 23,
      amount: "₹23,000",
      collectedPayment: "₹23,000",
      outstanding: "₹66,786",
    },
    {
      id: 4,
      salesPerson: "Sabarinathan S",
      phone: "PH: 9876543210",
      orders: 23,
      amount: "₹23,000",
      collectedPayment: "₹23,000",
      outstanding: "₹66,786",
    },
  ];

  const salesPersonsList = [
    { id: 1, name: "Arun Shelly", role: "Sales Head" },
    { id: 2, name: "Arun Shelly", role: "Sales Head" },
    { id: 3, name: "Arun Shelly", role: "Sales Head" },
    { id: 4, name: "Arun Shelly", role: "Sales Head" },
    { id: 5, name: "Arun Shelly", role: "Sales Head" },
    { id: 6, name: "Arun Shelly", role: "Sales Head" },
    { id: 7, name: "Arun Shelly", role: "Sales Head" },
    { id: 8, name: "Arun Shelly", role: "Sales Head" },
  ];

  const appointmentProgress = 65;
  const appointmentSummary = {
    total: 56,
    attended: 16,
    date: "23 May 2025",
  };

  const revenueComparison = {
    month: "May 2025",
    lastMonth: "₹25,00,000",
    thisMonth: "₹25,00,000",
  };

  const appointmentChartData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Target",
        data: [120, 140, 150, 145, 155, 160, 170, 165, 158, 162, 168, 172],
        backgroundColor: "#6D5FF6",
        borderRadius: 6,
        barThickness: 8,
      },
      {
        label: "Attended",
        data: [80, 95, 100, 98, 110, 115, 120, 118, 112, 116, 122, 125],
        backgroundColor: "#64B866",
        borderRadius: 6,
        barThickness: 8,
      },
    ],
  };

  const appointmentChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "#111827",
        bodyColor: "#111827",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        padding: 10,
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || "";
            const value = context.raw;
            return `${label} ${value}K`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#6b7280", font: { size: 12 } },
      },
      y: {
        beginAtZero: true,
        max: 200,
        ticks: {
          color: "#9ca3af",
          font: { size: 11 },
          callback: (value) => `${value}K`,
        },
        grid: { color: "#eef2f7" },
      },
    },
  };

  const getProgressColor = (percentage) => {
    if (percentage >= 75) return "#10b981";
    if (percentage >= 50) return "#f59e0b";
    return "#ef4444";
  };
  const createGradient = () => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 180, 180);
    gradient.addColorStop(0.2487, "#43B251");
    gradient.addColorStop(0.7262, "#75C130");
    return gradient;
  };
  const renderCircularProgress = (percentage) => {
    const chartData = {
      datasets: [
        {
          data: [percentage, 100 - percentage],
          backgroundColor: [createGradient(), "#e5e7eb"],
          borderWidth: 0,
          borderRadius: 10,
          circumference: 180,
          rotation: 270,
        },
      ],
    };

    const chartOptions = {
      responsive: false,
      maintainAspectRatio: false,
      cutout: "90%",
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
    };

    return (
      <div className="half-doughnut-container">
        <Doughnut
          data={chartData}
          options={chartOptions}
          style={{ width: "112px", height: "60px" }}
        />
        <div className="chart-center-text">
          <div className="percentage-text">{percentage}%</div>
          <div className="achieved-text">Achieved</div>
        </div>
      </div>
    );
  };

  return (
    <div className="salesperson-dashboard">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-tabs">
          <button onClick={() => navigate("/dashboard")} className="dashboard-tab-btn">
            Leads Hub
          </button>
          <button
            onClick={() => navigate("/revenue")}
            className="dashboard-tab-btn "
          >
            Revenue Overview
          </button>
          <button className="dashboard-tab-btn active">
            Sales Performance
          </button>
        </div>
        <div className="header-actions">
          <button className="filter-btn">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
            </svg>
            Filter by date range
          </button>
          <button className="download-btn">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
            Download report
          </button>
        </div>
      </div>

      {/* Top Metrics */}
      <div className="sales-metrics-grid">
        <div className="sales-metric-card">
          <div className="metric-icon ">
            <img src={targetIcon} alt="Targeted" />
          </div>
          <div className="metric-info">
            <div className="metric-label">Total Target</div>
            <div className="metric-values">
              <span className="metric-count">
                {metricsData.totalTarget.value}
              </span>
              <span className="metric-amount">
                {metricsData.totalTarget.amount}
              </span>
            </div>
          </div>
        </div>

        <div className="sales-metric-card">
          <div className="metric-icon ">
            <img src={achievedIcon} alt="Achieved" />
          </div>
          <div className="metric-info">
            <div className="metric-label">Total Achieved</div>
            <div className="metric-values">
              <span className="metric-count">
                {metricsData.totalAchieved.value}
              </span>
              <span className="metric-amount">
                {metricsData.totalAchieved.amount}
              </span>
            </div>
          </div>
        </div>

        <div className="sales-metric-card achievement">
          <div className="metric-icon">
            <img src={achievedPercentIcon} alt="Achievement Percent" />
          </div>
          <div className="achievement-content">
            <div className="achievement-label">Achievement %</div>
            <div className="achievement-value">
              {metricsData.achievementPercent}
            </div>
          </div>
        </div>

        <div className="sales-metric-card">
          <div className="metric-icon ">
            <img src={orderClosedIcon} alt="Orders Closed" />
          </div>
          <div className="metric-info">
            <div className="metric-label">Orders Closed</div>
            <div className="metric-values">
              <span className="metric-count">
                {metricsData.ordersClosed.value}
              </span>
              <span className="metric-amount">
                {metricsData.ordersClosed.amount}
              </span>
            </div>
          </div>
        </div>

        <div className="sales-metric-card">
          <div className="metric-icon">
            <img src={pendingIcon} alt="Pending Orders" />
          </div>
          <div className="metric-info">
            <div className="metric-label">Pending Orders</div>
            <div className="metric-values">
              <span className="metric-count">
                {metricsData.pendingOrders.value}
              </span>
              <span className="metric-amount">
                {metricsData.pendingOrders.amount}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Appointment Overview */}
      <div className="appointment-overview-section">
        <div className="appointment-left-column">
          <div className="appointment-card">
            <div className="appointment-card-header">
              <div className="appointment-title">
                <span className="appointment-icon">📅</span>
                <span>Appointment Overview</span>
              </div>
              <button className="appointment-date">
                {appointmentSummary.date}
                <span>▼</span>
              </button>
            </div>

            <div className="appointment-progress-container">
              <div className="appointment-progress-bar">
                <div
                  className="appointment-progress-fill"
                  style={{ width: `${appointmentProgress}%` }}
                />
                <div
                  className="appointment-progress-badge"
                  style={{ left: `${appointmentProgress}%` }}
                >
                  {appointmentProgress}%
                </div>
              </div>
              <div className="appointment-progress-scale">
                <span>0%</span>
                <span>100%</span>
              </div>
            </div>

            <div className="appointment-stats">
              <div className="appointment-stat">
                <div className="appointment-stat-label">Total Appointments</div>
                <div className="appointment-stat-value">
                  {appointmentSummary.total}
                </div>
              </div>
              <div className="appointment-stat">
                <div className="appointment-stat-label">
                  Attended Appointments
                </div>
                <div className="appointment-stat-value">
                  {appointmentSummary.attended}
                </div>
              </div>
            </div>
          </div>

          <div className="revenue-comparison-card">
            <div className="revenue-header">
              <div className="revenue-title">
                <span className="revenue-icon">📊</span>
                <span>Revenue Comparison</span>
              </div>
              <span className="revenue-date">{revenueComparison.month}</span>
            </div>
            <div className="revenue-body">
              <div className="revenue-col">
                <div className="revenue-label">Last Month</div>
                <div className="revenue-value">
                  {revenueComparison.lastMonth}
                </div>
              </div>
              <div className="revenue-divider" />
              <div className="revenue-col">
                <div className="revenue-label">This Month</div>
                <div className="revenue-value">
                  {revenueComparison.thisMonth}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="appointment-chart-card">
          <div className="appointment-chart-header">
            <div className="appointment-chart-title">Appointment Overview</div>
            <div className="appointment-chart-controls">
              <span className="appointment-chart-month">June, 2024</span>
              <button className="appointment-chart-nav">‹</button>
              <button className="appointment-chart-nav">›</button>
            </div>
          </div>
          <div className="appointment-chart-body">
            <Bar
              data={appointmentChartData}
              options={appointmentChartOptions}
            />
          </div>
        </div>
      </div>

      {/* Performance Tabs */}
      <div className="performance-tabs">
        <button
          className={performanceTab === "Top Sales Persons" ? "active" : ""}
          onClick={() => setPerformanceTab("Top Sales Persons")}
        >
          Top Sales Persons
        </button>
        <button
          className={performanceTab === "Least Sales Persons" ? "active" : ""}
          onClick={() => setPerformanceTab("Least Sales Persons")}
        >
          Least Sales Persons
        </button>
      </div>

      {/* Sales Persons Grid */}
      <div className="salesperson-grid">
        {salesPersonsData.map((person) => (
          <div key={person.id} className="salesperson-card">
            <div className="card-header-row">
              <div className="person-info">
                <div className="avatar-circle">
                  {person.profileImage ? (
                    <img src={person.profileImage} alt={person.name} />
                  ) : (
                    <span>👤</span>
                  )}
                </div>
                <div className="person-details">
                  <div className="person-name">{person.name}</div>
                  <div className="person-role">{person.role}</div>
                </div>
              </div>
              <div className={`rank-badge rank-${person.rank}`}>
                🏆 #{person.rank}
              </div>
            </div>

            <div className="progress-section">
              {renderCircularProgress(person.achievement)}
            </div>

            <div className="revenue-section">
              <span className="revenue-amount">{person.revenue}</span>
              <span className="revenue-separator"> / </span>
              <span className="revenue-target">{person.target}</span>
            </div>

            <div className="stats-row">
              <div className="stat-item">
                <div className="stat-info">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <div className="stat-icon-new">
                      <img
                        src={revenueIcon}
                        alt="Revenue"
                        style={{ width: "16px", height: "16px" }}
                      />
                    </div>
                    <div className="stat-label">Revenue</div>
                  </div>
                  <div className="stat-value">{person.revenue}</div>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-info">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <div className="stat-icon-new">
                      <img
                        src={orderIcon}
                        alt="Orders"
                        style={{ width: "16px", height: "16px" }}
                      />
                    </div>
                    <div className="stat-label">Orders</div>
                  </div>
                  <div className="stat-value">{person.orders}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Performance Summary */}
      <div className="performance-summary-section">
        <h3>Performance Summary</h3>
        <div className="summary-tabs">
          <button
            className={summaryTab === "Sales Persons" ? "active" : ""}
            onClick={() => setSummaryTab("Sales Persons")}
          >
            Sales Persons
          </button>
          <button
            className={summaryTab === "Locations" ? "active" : ""}
            onClick={() => setSummaryTab("Locations")}
          >
            Locations
          </button>
        </div>
        {/* Performance Table */}
        <div className="mt-2 performance-table-section">
          <table className="performance-table">
            <thead>
              <tr>
                <th>Sales Person</th>
                <th>Orders</th>
                <th>Amount</th>
                <th>Collected Payment</th>
                <th>Outstanding</th>
              </tr>
            </thead>
            <tbody>
              {performanceSummary.map((item) => (
                <tr key={item.id}>
                  <td>
                    <div className="salesperson-cell">
                      <div className="sp-avatar">S</div>
                      <div className="sp-info">
                        <div className="sp-name">{item.salesPerson}</div>
                        <div className="sp-phone">{item.phone}</div>
                      </div>
                    </div>
                  </td>
                  <td>{item.orders}</td>
                  <td style={{ color: "#454CF2", fontWeight: "500" }}>
                    {item.amount}
                  </td>
                  <td style={{ color: "#454CF2", fontWeight: "500" }}>
                    {item.collectedPayment}
                  </td>
                  <td style={{ color: "#454CF2", fontWeight: "500" }}>
                    {item.outstanding}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="map-section">
          <div className="map-header"></div>

          <div className="content-grid">
            {/* Map View */}
            <div className="map-container">
              <button className="map-view-toggle">Live view</button>
              <div className="map-placeholder">
                {/* Placeholder for actual map integration */}
                <div className="map-info">
                  <p>Map integration placeholder</p>
                  <p className="map-note">
                    Integrate with Google Maps or similar service
                  </p>
                </div>
              </div>
            </div>

            {/* Sales Persons List */}
            <div className="persons-list-panel">
              <div className="list-header">
                <h4>Sales Persons - 23</h4>
                <div className="search-box">
                  <input type="text" placeholder="🔍 Search" />
                </div>
              </div>
              <div className="persons-list">
                {salesPersonsList.map((person) => (
                  <div key={person.id} className="person-item">
                    <input type="checkbox" />
                    <div className="person-avatar">
                      <span>👤</span>
                    </div>
                    <div className="person-info-text">
                      <div className="name">{person.name}</div>
                      <div className="role">{person.role}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalespersonDashboard;
